import { Box as MuiBox } from "@mui/material";
import styled from "@emotion/styled";
import { APP_HEADER_HEIGHT } from "@/layouts/MainLayout/components/MainHeader.style";

export const MainBodyPage = styled(MuiBox)({
  height: `calc(100vh - ${APP_HEADER_HEIGHT + 16 + 1}px)`, // 1px is divider line, 16px is padding
  display: "flex",
  flexDirection: "column",
  gap: 8,
});

export const TableContainer = styled(MuiBox)({
  flexGrow: 1,
  overflow: "auto",
});
